import pick from 'lodash/pick';
import { useController } from 'react-hook-form';
import { hookFormControllerProps } from './utils/hookFormControllerProps';
/** Represents a hook for creating a React Hook Form based component. */
export function useHookForm(props) {
    const controllerProps = pick(props, hookFormControllerProps);
    const controller = useController(controllerProps);
    return {
        controller,
        controllerProps,
    };
}
